<script lang="ts">
import { computed, defineComponent } from 'vue';
import { Pagination as APagination } from 'ant-design-vue';
import {
  any, func, object, string,
} from 'vue-types';

interface PaginationValues {
  total: number;
  perPage: number;
  currentPage: number;
}

const goToScroll = (tagName: string) => {
  const body = document.getElementsByTagName(tagName);
  if (body[0]) {
    body[0].scrollIntoView({ behavior: 'smooth' });
  }
};

export default defineComponent({
  name: 'Pagination',

  components: {
    APagination,
  },

  props: {
    onChange: func<(page: number, pageSize: number) => void>().isRequired,
    pagination: object<PaginationValues>().isRequired,
    itemsLabel: string(),
    scroll: string(),
    size: string<'default' | 'small'>(),
    class: any(),
    showTotal: Boolean,
    showSizeChanger: Boolean,
  },
  setup(properties) {
    const label = computed(() => properties.itemsLabel ?? 'items');
    const getTotal = (total: number, range: [number, number], itemsLabel: string) => `${range[0]} - ${range[1]} of ${total} ${itemsLabel}`;
    const showTotalFn = (total: number, range: [number, number]) => getTotal(total, range, label.value);
    return {
      showTotalFn,
    };
  },
  methods: {
    onShowSizeChange(current: number, pageSize: number) {
      this.onChange(1, pageSize);
    },
    onChangeInternal(page: number, perPage: number) {
      if (this.scroll) {
        goToScroll(this.scroll);
      }
      this.onChange(page, perPage ?? this.pagination.currentPage);
    },
  },
});
</script>

<template>
  <div :class="$props.class">
    <APagination
      :size="size"
      :show-total="
        showTotal ? showTotalFn : undefined
      "
      :current="pagination.currentPage"
      :total="pagination.total"
      :page-size="pagination.perPage"
      :show-size-changer="showSizeChanger"
      @change="onChangeInternal"
      @show-size-change="onShowSizeChange"
    />
  </div>
</template>
